import type { CSSProperties } from "react";

/**
 * The exhibit/ledger tokens read by DATA_LABEL_CLS, the dotted rules and the
 * metadata rows (`--rule`, `--rule-soft`, `--type-label`, `--type-label-small`,
 * `--type-data`). Light for cream grounds, dark for the deep surface. Spread
 * onto the nearest wrapper; do not re-declare these per file.
 */
export const EDITORIAL_LIGHT_TOKENS = {
  "--rule": "color-mix(in srgb, var(--theme-ink) 22%, transparent)",
  "--rule-soft": "color-mix(in srgb, var(--theme-ink) 7%, transparent)",
  "--type-label": "0.6875rem",
  "--type-label-small": "0.6875rem",
  "--type-data": "0.75rem",
} as CSSProperties;

export const EDITORIAL_DARK_TOKENS = {
  "--rule": "color-mix(in srgb, var(--theme-ground) 22%, transparent)",
  "--rule-soft": "color-mix(in srgb, var(--theme-ground) 6%, transparent)",
  "--type-label": "0.6875rem",
  "--type-label-small": "0.6875rem",
  "--type-data": "0.75rem",
} as CSSProperties;
